import { render, staticRenderFns } from "./ModalSetDevicePos.vue?vue&type=template&id=123567a5&scoped=true"
import script from "./ModalSetDevicePos.vue?vue&type=script&lang=js"
export * from "./ModalSetDevicePos.vue?vue&type=script&lang=js"
import style0 from "./ModalSetDevicePos.vue?vue&type=style&index=0&id=123567a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123567a5",
  null
  
)

export default component.exports